import React from "react";

function Home() {
  return (
    <div className="home">
      <video className="myVideo" muted loop autoPlay>
        <source src="images/background2.mp4" type="video/mp4" />
      </video>
      <div className="videoContent">
        <div>
          <img src="images/men-2.png" alt="" />
        </div>
        <div>
          <p>
            There is no end to the science in the world, but there is an end to
            the knowledge in people, most people think that these people will
            end up being geniuses but I think the end of science in people is to
            read until they are crazy !

          </p>
        </div>
      </div>
    </div>
  );
}

export default Home;
